<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div :class="`col-12 col-md-12 col-lg-4`">
            <label for="">{{ $t('common_words.company') }}: * </label>
            <br />
            <el-select
              clearable
              @change="preventBusinessLoadError()"
              collapse-tags
              style="width: 100%"
              filterable
              class="select-primary custom-width-select shadow-sm required-business_id"
              v-model="filter.business_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="item in businesses"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-2">
            <label>{{ $t('common_words.year') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              type="year"
              @change="preventYearLoadError()"
              class="shadow-sm required-year"
              v-model="filter.year_sel"
              value-format="yyyy"
              :clearable="false"
              :placeholder="`${$t('common_words.select2')}...`"
            />
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
            <div class="row custom-mt-30">
              <div class="col-12 col-sm-6 col-md-4 mb-2">
                <l-button
                  wide
                  type="info"
                  class="btn-filter"
                  @click="validateForm"
                  style="width: inherit"
                >
                  {{ $t('common_words.generate') }}
                </l-button>
              </div>
            </div>
          </div>
        </div>
      </card>
      <card class="custom-shadow-card-header" v-if="haveCalendars">
        <form>
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <div class="form-group has-label">
                  <el-upload
                    drag
                    ref="upload"
                    :action="getAxiosURL() + '/auth/production/budget/preload'"
                    :data="{
                      business_id: filter.business_id,
                      year_sel: filter.year_sel,
                    }"
                    :headers="headerInfo"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    :on-error="handleUploadError"
                    :auto-upload="false"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      {{ $t('common_words.finished_format') }}
                      <em>{{ $t('common_words.click_to_load') }}</em>
                    </div>
                    <div slot="tip" class="el-upload__tip">
                      {{ $t('common_words.xlsx_notice') }}
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-center" v-if="isCreate()">
                <button
                  style="margin-right: 10px"
                  class="btn btn-info btn-fg"
                  @click.prevent="downloadFormat"
                >
                  <i class="fa fa-file-excel-o"></i>
                  {{ $t('common_words.download_file') }}
                </button>
                <button
                  class="btn btn-info btn-fg"
                  @click.prevent="submitUpload"
                >
                  <i class="fa fa-plus"></i> {{ $t('common_words.load_file') }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      filter: {
        business_id: null,
        year_sel: null,
      },
      businesses: [],
      farmsWithCalendar: [],
      haveCalendars: false,
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
        Accept: 'application/json',
      },
    };
  },
  mixins: [
    MixinExport,
    MixinForm,
    MixinValidations,
    MixinPermissions,
    MixinMenu,
    mixinMasters,
    MixinLoading,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },
  methods: {
    validateForm() {
      if (!isset(this.filter.business_id)) {
        return this.validationInputsRequired('business_id');
      } else if (!isset(this.filter.year_sel)) {
        return this.validationInputsRequired('year');
      } else {
        this.verifyCalendar();
      }
    },
    cleanAll() {
      this.filter.business_id = null;
      this.filter.year_sel = null;
      this.haveCalendars = false;
      this.farmsWithCalendar = [];
    },
    preventBusinessLoadError() {
      this.haveCalendars = false;
      this.farmsWithCalendar = [];
    },
    preventYearLoadError() {
      this.haveCalendars = false;
      this.farmsWithCalendar = [];
    },
    verifyCalendar() {
      this.showHideLoading(true);
      this.haveCalendars = false;
      let data = { ...this.filter };
      data.route = 'calendar/businesscalendarbyyear';
      Axios.postMasters(data)
        .then((response) => {
          this.farmsWithCalendar = response.data;
          if (this.farmsWithCalendar.length == 0) {
            SweetAlert.warning(
              i18n.t('productionbudget.no_calendar_configured')
            );
          } else {
            this.haveCalendars = true;
          }
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    handleExceed(files, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.ground.selected_limit')} ${
          files.length
        } ${i18n.t('sweet_alert.ground.files')} `
      );
    },
    handleSuccess(res, file) {
      const errors = Array.isArray(res.errors) ? res.errors : [];
      const data = res.data && typeof res.data === 'object' ? res.data : null;
      const message = res.message || '';

      if (errors.length > 0) {
        let html = errors.map((e) => `<p>${e}</p>`).join('');
        if (message) html += `<hr/><p><strong>${message}</strong></p>`;

        SweetAlert.warning(html);
      } else if (data) {
        let html = `<p><strong>${message}</strong></p>`;
        SweetAlert.success(html);
        this.cleanAll();
      } else {
        SweetAlert.info(i18n.t('common_words.no_new_data_was_recorded'));
      }
      this.$refs.upload.clearFiles();
    },
    beforeUpload(file) {
      const validateDocument = this.validateDocument(file.type);
      if (!validateDocument) {
        return false;
      }
    },
    handleUploadError(error, file, fileList) {
      let response = null;

      try {
        response = JSON.parse(error.message);
      } catch (e) {
        response = error && error.response ? error.response : null;
      }

      const data = response && response.data ? response.data : response || {};
      const errors = Array.isArray(data.errors) ? data.errors : [];
      const message = data.message || '';

      if (errors.length > 0) {
        let html = errors.map((e) => `<p>${e}</p>`).join('');
        if (message) {
          html += `<hr/><p><strong>${message}</strong></p>`;
        }

        SweetAlert.warning(html);
      } else if (message) {
        SweetAlert.warning(message);
      } else {
        SweetAlert.warning(i18n.t('common_words.file_load_error'));
      }

      this.$refs.upload.clearFiles();
    },
    validateDocument(fileType) {
      const isXLSX = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'application/wps-office.xlsx',
      ].includes(fileType);
      if (!isXLSX) {
        SweetAlert.warning(`${i18n.t('common_words.xlsx_format_notice')}`);
        return false;
      }
      return true;
    },
    downloadFormat() {
      let self = this;
      let data = self.filter;
      data.farmsCalendars = this.farmsWithCalendar;
      data.route = 'production/budget/preformat';
      data.name_file = `${i18n.t(
        'productionbudget.production_budget_preload'
      )}_${this.filter.year_sel}.xlsx`;
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([Axios.getMasters('businesses/only')])
        .then((response) => {
          const [responseBusiness] = response;
          this.businesses = responseBusiness.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('production');
  },

  destroyed() {
    this.deselectedItemOnMenu('production');
  },
};
</script>
